import { Badge } from "@/components/ui/Badge";
import { Card, CardBody } from "@/components/ui/Card";
import { HoverHintWithGlyph } from "@/components/ui/title-help";
import type { WorkOrderStatusSourceRow } from "@integrator-src/manufacturing/work-order-status-unified";

import { effectiveWorkOrderStatus, statusToneForWorkOrder } from "./workOrdersPageModel";

export function StatusPill({ row }: { row: WorkOrderStatusSourceRow }) {
  return <Badge tone={statusToneForWorkOrder(row)}>{effectiveWorkOrderStatus(row)}</Badge>;
}

export function SummaryCard({ label, value, helper }: { label: string; value: string; helper: string }) {
  return (
    <Card>
      <CardBody>
        <div className="flex items-center gap-1.5 text-sm font-medium text-slate-500">
          <span>{label}</span>
          <HoverHintWithGlyph hoverHint={helper} />
        </div>
        <div className="mt-2 text-2xl font-semibold leading-tight tracking-tight text-slate-950 tabular-nums">
          {value}
        </div>
      </CardBody>
    </Card>
  );
}
